import axiosApiInstance from '../../interceptors/axiosApiInstance';
import { BASE_URL } from '../config';

const ApplicationService = {
    getApplications: async function (params) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/application`, { params });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getApplicationConnectorConfigurations: async function (params = {}) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/application/configurations/connector`, { params });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getApplicationTriggerConfigurations: async function (params = {}) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/application/configurations/trigger`, { params });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getApplicationTriggerSetup: async function (params = {}) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/application/configurations/setup`, { params });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getAppCredentials: async function (params = {}) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/application/credentials`, { params });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getAppCredentialList: async function () {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/application/credential-list`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getAppCredential: async function (id) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/application/credential/${id}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getSetupFields: async function (params) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/application/configurations/setup/fields`, { params });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getApplicationActionConfigurationFields: async function (params) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/application/configurations/fields`, { params });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    testAppCredential: async function (data) {
        try {
            const response = await axiosApiInstance.post(BASE_URL + `/application/credential/test`, data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    createAppCredential: async function (data) {
        try {
            const response = await axiosApiInstance.post(BASE_URL + `/application/credential`, data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    updateAppCredential: async function (id, data) {
        try {
            const response = await axiosApiInstance.put(BASE_URL + `/application/credential/${id}`, data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    deleteAppCredentials: async function (ids) {
        try {
            const response = await axiosApiInstance.delete(BASE_URL + `/application/credentials`, {
                data: {
                    ids,
                },
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    }
};

export default ApplicationService;
